import React from 'react';
import { Box } from '@mui/material';

export interface RoleplayTimerBlockProps {
  sessionTime: number;
  estimatedTime: number;
  formatTime: (seconds: number) => string;
  getTimeColor: () => string;
}

export const RoleplayTimerBlock: React.FC<RoleplayTimerBlockProps> = ({
  sessionTime,
  estimatedTime,
  formatTime,
  getTimeColor,
}) => (
  <Box sx={{
    position: 'absolute',
    top: '79px',
    left: '18px',
    zIndex: 3,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    minWidth: '162px',
  }}>
    <Box sx={{ display: 'flex', gap: '4px' }}>
      <Box sx={{
        fontSize: '12px',
        fontWeight: 400,
        padding: '2px 10px',
        borderRadius: '0px',
        color: '#fff',
        bgcolor: '#6C9AD7',
        width: '80px',
        textAlign: 'center',
        letterSpacing: '12%',
      }}>
        経過時間
      </Box>
      <Box sx={{
        fontSize: '12px',
        fontWeight: 400,
        padding: '2px 10px',
        borderRadius: '0px',
        color: '#fff',
        bgcolor: '#25507A',
        width: '80px',
        textAlign: 'center',
        letterSpacing: '12%',
      }}>
        目安時間
      </Box>
    </Box>
    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <Box sx={{
        width: '80px',
        height: '22px',
        fontSize: '22px',
        fontFamily: 'HelveticaNeue,Meiryo,sans-serif',
        bgcolor: 'transparent',
        color: getTimeColor() === 'error' ? '#f44336' : (getTimeColor() === 'warning' ? '#ff9800' : '#25507A'),
        padding: '3px 4px',
        borderRadius: '0px',
        fontWeight: 400,
        textAlign: 'right',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}>
        {formatTime(sessionTime)}
      </Box>
      <Box sx={{
        width: '80px',
        height: '22px',
        fontSize: '22px',
        fontFamily: 'HelveticaNeue,Meiryo,sans-serif',
        bgcolor: 'transparent',
        color: '#25507A',
        padding: '3px 17.5px',
        borderRadius: '0px',
        fontWeight: 400,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0px',
      }}>
        <span>{estimatedTime}</span>
        <span style={{ fontSize: '14px', marginLeft: '0px' }}>分</span>
      </Box>
    </Box>
  </Box>
);
